/**
 *
 *
 * @author fuyg
 * @date  2020-06-03
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from 'src/pages/home/store'
import { getYearReport, YearReportParams } from 'src/pages/home/apis/report'
import { InvestorEvent } from 'src/pages/home/apis/recentInvestorEvents'

interface ReportState {
  loading: boolean
  error: string
  report: InvestorEvent[]
}

const initialState: ReportState = {
  loading: false,
  error: '',
  report: [],
}

const reportSlice = createSlice({
  name: 'reportSlice',
  initialState,
  reducers: {
    getDataStart(state): void {
      state.loading = true
    },
    getDataSuccess(state, action: PayloadAction<InvestorEvent[]>): void {
      state.loading = false
      const { payload } = action
      if (payload && payload.length >= 0) {
        state.report = action.payload
      }
    },
    getDataError(state, action: PayloadAction<string>): void {
      state.loading = false
      state.error = action.payload
    },
  },
})

export const {
  getDataStart,
  getDataSuccess,
  getDataError,
} = reportSlice.actions

export default reportSlice.reducer

export const fetchYearReport = (params: YearReportParams): AppThunk => async (
  dispatch,
): Promise<void> => {
  try {
    dispatch(getDataStart())
    const data = await getYearReport(params)
    dispatch(getDataSuccess(data))
  } catch (err) {
    dispatch(getDataError(err as string))
  }
}
